import { Outlet } from "react-router-dom";
import InvalidPage from "./InvalidPage";

const PublicRoute = ({ sessionExpired }) => {
    // Show invalid page if the user is logged in and tried to access public route
	return sessionExpired ? <Outlet /> : <InvalidPage />;
};

export default PublicRoute;
